const getUrlToken = (): string | undefined =>
	window.location.href.split("?token=")[1]?.split("#")[0]
export default getUrlToken
